export default __webpack_public_path__ + "static/media/employee_template.c348bcf0.xlsx";